import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import AutoFocus from 'formvalidation/es6/plugins/AutoFocus';

(function(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function() {

    var scrollDown = document.querySelector('.scroll-link');
    scrollDown.addEventListener('click', function(e) {
        e.preventDefault();
        document.getElementById('write_for_us').scrollIntoView({ behavior: 'smooth' });
    });

    //add url
    [].forEach.call(document.querySelectorAll('.add-more'), function(elem) {
        elem.addEventListener('click', function(e) {
            var userUrl = document.querySelectorAll('.user-url.hidden');
            if(userUrl[0]) {
                userUrl[0].classList.remove('hidden');
            }
        });
    });

    var submitForm = document.getElementById('submit_form');
    if(submitForm) {
        var captchaMessage = document.getElementById('captcha_container').getAttribute('data-fv-not-empty___message');

        // form validation
        var fv = formValidation(submitForm, {
            plugins: {
                trigger: new Trigger({
                    event: 'blur'
                }),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                autoFocus: new AutoFocus(),
                declarative: new Declarative({
                    html5Input: true
                }),
                recaptcha: new Recaptcha({
                    element: 'captcha_container',
                    siteKey: '6LcyWRsUAAAAALEi23AyVvcTogjVqGKCAkqZmCbq',
                    message: captchaMessage
                })}
            }
        );
    }

});